"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _uniqid = _interopRequireDefault(require("uniqid"));

var _classnames = _interopRequireDefault(require("classnames"));

var _accent = require("../_constants/accent");

var _chip = _interopRequireDefault(require("./chip"));

require("./chips.sass");

var Chips =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Chips, _Component);

  function Chips() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Chips);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Chips)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "hasAccent", function (dataItem) {
      return (0, _isObject.default)(dataItem) && dataItem.hasOwnProperty('accent');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderChip", function (dataItem) {
      var keyField = _this.props.keyField;
      var key = keyField ? dataItem[keyField] : (0, _uniqid.default)();

      if (_this.hasAccent(dataItem)) {
        return _react.default.createElement(_chip.default, {
          key: key,
          data: dataItem.info,
          accent: dataItem.accent
        });
      } else {
        return _react.default.createElement(_chip.default, {
          key: key,
          data: dataItem
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Chips, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          children = _this$props.children,
          wide = _this$props.wide,
          className = _this$props.className;
      var composedClassName = (0, _classnames.default)('chips', className, {
        'chips--wide': wide
      });
      return _react.default.createElement("div", {
        className: composedClassName
      }, children ? children : data.map(this.renderChip));
    }
  }]);
  return Chips;
}(_react.Component);

exports.default = Chips;
(0, _defineProperty2.default)(Chips, "defaultProps", {
  data: [],
  wide: false
});
Chips.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
    info: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    accent: _propTypes.default.oneOf(_accent.accents)
  })])),
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]),
  keyField: _propTypes.default.string,
  className: _propTypes.default.string,
  wide: _propTypes.default.bool
} : {};